import { MoneTracker } from 'Services/MoneTracker';
import { getTrackSource } from 'Services/MoneTracker/utils';

const TYPE = 'audio_player_queue';

const trackEvent = ({
  type = TYPE,
  source,
  action,
  data,
}: {
  action: string;
  type?: string;
  source?: string;
  data?: Readonly<Record<string, any>>;
}) => {
  MoneTracker.trackEvent({
    type,
    source: source ?? getTrackSource(),
    action,
    data,
  });
};

export const trackAddToQueueFromNextUp = (entityId: string) => {
  trackEvent({
    action: 'click:add',
    source: 'queue:next_up',
    data: {
      audio_id: entityId,
    },
  });
};

export const trackAddToQueueFromPage = (entityId: string) => {
  trackEvent({
    action: 'click:add',
    data: {
      audio_id: entityId,
    },
  });
};

export const trackQueueShown = (entityId: string) => {
  trackEvent({
    action: 'shown',
    data: {
      audio_id: entityId,
    },
  });
};

export const trackOpenQueue = (entityId: string) => {
  trackEvent({
    action: 'click:open_tray',
    data: {
      audio_id: entityId,
    },
  });
};

export const trackDownloadClick = ({
  entityId,
  title,
  source,
}: {
  entityId: string;
  title: string;
  source?: string;
}) => {
  trackEvent({
    action: 'click:download',
    source,
    data: {
      provider: 'SA_audio_player',
      audio_id: entityId,
      audio_unit: title,
    },
  });
};

export const trackOpenArticlePageClick = ({
  entityId,
  title,
  source,
}: {
  entityId: string;
  title: string;
  source?: string;
}) => {
  trackEvent({
    action: 'click:article',
    source,
    data: {
      provider: 'SA_audio_player',
      audio_id: entityId,
      audio_unit: title,
    },
  });
};

export const trackNextUpTurnedOff = () => {
  trackEvent({
    action: 'click:toggle_off',
    source: 'queue:next_up',
  });
};
